import { graphql, useMutation } from "react-relay";
import { useUploadImage } from "arkh";
import { useCallback } from "react";
import { useWorkspaceSignalEditAddImageMutation } from "./__generated__/useWorkspaceSignalEditAddImageMutation.graphql";

export function useWorkspaceSignalEditAddImage(id: string) {
  const [addImageMutation] =
    useMutation<useWorkspaceSignalEditAddImageMutation>(graphql`
      mutation useWorkspaceSignalEditAddImageMutation($signalId: ID!) {
        signalWorkspace(id: $signalId) {
          uploadImage {
            image {
              id
            }
            imageUploadUrl
            signalWorkspace {
              id
              ...WorkspaceSignalEditMainEditedInfo_Signal
              descriptionImages {
                id
              }
            }
          }
        }
      }
    `);

  const { uploadImage, prepareForImageUpload } = useUploadImage();
  const addImage = useCallback(
    async (
      uri: string,
      { width, height }: { width: number; height: number }
    ) => {
      const uploadIdRequest = prepareForImageUpload({
        width,
        height,
        localImageURI: uri,
      });
      return addImageMutation({
        onCompleted: (data) => {
          if (data.signalWorkspace?.uploadImage.imageUploadUrl) {
            uploadIdRequest.then((uploadId) => {
              uploadImage({
                imageId: data.signalWorkspace?.uploadImage.image.id,
                uploadURL: data.signalWorkspace?.uploadImage.imageUploadUrl,
                uploadId,
              });
            });
          }
        },
        variables: {
          signalId: id,
        },
      });
    },
    [addImageMutation, id, prepareForImageUpload, uploadImage]
  );

  return addImage;
}
